let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g4Ezq")).then(() => parcelRequire('8MEkZ'));